{
  "title": "Invoice",
  "number": "Invoice No.",
  "date": "Date",
  "due_date": "Due date",
  "customer": "Customer",
  "items_table": {
    "description": "Description",
    "quantity": "Qty",
    "unit_price": "Unit price (excl. tax)",
    "total": "Total (excl. tax)"
  },
  "summary": {
    "subtotal_ht": "Subtotal (excl. tax)",
    "tva": "VAT (18%)",
    "total_ttc": "Total (incl. tax)"
  },
  "status": {
    "label": "Status",
    "draft": "Draft",
    "issued": "Issued",
    "paid": "Paid",
    "cancelled": "Cancelled",
    "refunded": "Refunded"
  },
  "actions": {
    "view": "View",
    "download_pdf": "Download PDF",
    "print": "Print",
    "send_email": "Send by email"
  },
  "company": {
    "legal_notice": "CIEDA SARL — Hann Mariste II, Dakar, Senegal",
    "ninea": "NINEA",
    "rc": "RC",
    "payment_terms": "Payment terms: Payment at order"
  },
  "list": {
    "title": "My invoices",
    "column_status": "Status",
    "empty": "No invoices",
    "empty_description": "Your invoices will appear here after your first order"
  },
  "customer_page": {
    "title": "My invoices",
    "empty_title": "No invoices available",
    "empty_message": "Your invoices will appear here after your orders."
  },
  "admin": {
    "title": "Invoice management",
    "column_number": "Invoice No.",
    "column_date": "Date",
    "column_customer": "Customer",
    "column_total": "Total (incl. tax)",
    "column_status": "Status",
    "column_actions": "Actions",
    "filter_all": "All",
    "filter_issued": "Issued",
    "filter_paid": "Paid",
    "filter_cancelled": "Cancelled",
    "search_placeholder": "Search invoice…",
    "pagination_of": "of",
    "pagination_results": "results",
    "no_results": "No results",
    "no_results_description": "No invoice matches your search criteria."
  },
  "qr": {
    "scan_to_verify": "Scan to verify"
  }
}
